import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SearchResult } from '../models/search-result.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(
    private http: HttpClient,
    private api: ApiService
  ) { }

  private BaseURL: string = 'https://proxy.payanywhere.dev';

  //#region Payment-by-link

  private proxyApiUrl = '/payment'; // Use the local proxy path

  getAuthToken(): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // This header is important
        'X-NabWss-AppSource': 'pa-isv-759e7b5034d974996123d717e0a0ea4b'
      })
    };

    const body: any = {
      "mid": "3130030852422",
      "developerKey": "976b7e262e36b4f7dddbb1e36e50fea2",
      "password": "RDOvHi1FxSz9pbQUYBPJcBmfQJlpKxf2bG3PIQ20Hm+n9osoY/X/yS6dzaqEju0VH64e5NfMFtlawxYB4+a1lg=="
    };
    

    // The post request now goes to the local proxy URL
    return this.http.post<any>(this.proxyApiUrl + '/auth', body, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  createPaymentLink(account_id: string, authToken: string, invoice_details: any): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // This header is important
        'X-NabWss-AppSource': 'pa-isv-759e7b5034d974996123d717e0a0ea4b',
        'Authorization': `Bearer ${authToken}`
      })
    };

    const body: any = {
        "type": "ondemand",
        "qrcode": true,
        "invoice": { 
          "customer": {
            "first_name": invoice_details.client_firstname,
            "last_name": invoice_details.client_lastname,
            "email_addresses": [
              invoice_details.client_email
            ]
          },
          "name": invoice_details.name,
          "description": invoice_details.description,
          "number": invoice_details.number,
          "due_date": invoice_details.due_date,
          "send_date": invoice_details.send_date,
          "amount": invoice_details.amount,
          "tax_rate": invoice_details.tax_rate,
          "service_fee_enabled": false
        }
    };
    

    // The post request now goes to the local proxy URL
    return this.http.post<any>(this.proxyApiUrl + `/accounts/${account_id}/invoices`, body, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  } 

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) { 
      errorMessage = `Client-side error: ${error.error.message}`;
    } else { 
      errorMessage = `Server returned code ${error.status}, body was: ${JSON.stringify(error.error)}`;
    }
    console.error(errorMessage); 
    return throwError(() => new Error('Authentication failed; please try again later.'));
  }
  //#endregion
 
  //#region Payment-by-link using Authorize.Net
  //http://localhost:5000/api/payments/accept-hosted-token
  
  
  getHostedToken(amount: number) { 
      const httpOptions = {
        amount, 
      }
      let promise = new Promise((resolve, reject) => {
          this.api.post<SearchResult>(`payments/accept-hosted-token`, httpOptions)
              .subscribe((res: any) => {
                  if (res) {   
                      resolve(res.token);
                  } else { 
                      resolve(0);
                  }
              });
      });
      return promise;
  } 
  //#endregion

}
